<template>
  <div>
    <div class="method-tab" :style="bgimg" v-if="!contentPage">
      <div class="tab-title">
        <img :src="title">
      </div>
      <div class="subtitle" :class="lngClass" v-html="$t('page.pyby-subtitle')"></div>
      <div class="content-show" @click="contentPage = true">
        <span :class="lngClass">{{ $t("base.view-details") }}</span>
        <img src="@/assets/img/content-show.png">
      </div>
    </div>
    <transition name="slide">
      <div
        class="method-content"
        v-if="contentPage"
      >
        <m-textarea ref="subdataArea">
          <div v-html="content" :class="{ video: onTabThr }" ref="subData"></div>
        </m-textarea>
        <ul class="sub-tabs">
          <li
            v-for="(item, index) in tabData.subtabs"
            :class="subTabClass(index)"
            :key="index"
            @click="subContect(index)"
          >
            <div v-html="item"></div>
          </li>
        </ul>
        <Arrow class="btn-arrow" type="back" @arrowClick="contentPage = false"></Arrow>
      </div>
    </transition>

    <VideoPlay
      v-if="videoPlayer"
      :info="videoInfo"
      @closePlayer="videoPlayer = false"
    ></VideoPlay>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import TextArea from "@/components/TextArea.vue";
import Arrow from "@/components/Arrow.vue";
import VideoPlay from "@/components/VideoPlay.vue";

export default {
  props: {
    tabData: Object
  },
  components: {
    "m-textarea": TextArea,
    Arrow,
    VideoPlay
  },
  data() {
    return {
      subTab: 0,
      contentPage: false,
      videoPlayer: false,
      videoIndex: 0,
      videos: [
        {
          title: "远虚近实",
          url: "/py/bymethod/yxjs.mp4"
        },
        {
          title: "烟雾弥漫",
          url: "/py/bymethod/ywmm.mp4"
        },
        {
          title: "喷火",
          url: "/py/bymethod/ph.mp4"
        },
        {
          title: "张口合眼",
          url: "/py/bymethod/zkhy.mp4"
        },
        {
          title: "水波振荡",
          url: "/py/bymethod/sbdy.mp4"
        },
        {
          title: "斩首变脸",
          url: "/py/bymethod/zsbl.mp4"
        }
      ]
    };
  },
  computed: {
    ...mapState(["pyby"]),
    ...mapGetters(["lngClass"]),
    title() {
      return this.tabData.ttimg;
    },
    bgimg() {
      const bgurl = this.tabData.bgimg;
      return { backgroundImage: `url("${bgurl}")` };
    },
    content() {
      const data = this.pyby.method;
      if (data) {
        return data[this.subTab];
      }
    },
    onTabThr() {
      return this.subTab === 3
    },
    videoInfo() {
      return this.videos[this.videoIndex]
    }
  },
  mounted() {
    this.getSubContent({
      page: "pyby",
      tab: this.tabData.name,
      subtab: this.tabData.subtabs.length
    });
  },
  methods: {
    ...mapActions(["getSubContent"]),
    subTabClass(index) {
      return index === this.subTab ? "active" : "";
    },

    subContect(index) {
      this.subTab = index;
      this.$refs.subdataArea.scroll();
      if (index === 3) {
        this.$nextTick(() => {
          const titles = this.$refs.subData.getElementsByTagName("h3");
          const that = this;
          for (let i = 0; i < titles.length; i++) {
            titles[i].addEventListener("click", function(){
              that.videoIndex = i;
              that.videoPlayer = true;
            })
          }
        })
      }
    }

  }
};
</script>

<style lang="scss">
@import "~@/assets/base";
.method-tab {
  position: relative;
  height: 100vh;
  background-size: cover;

  .tab-title {
    position: absolute;
    left: 1.5rem;
    top: 3rem;
    @include scaleimg(0.5);
  }

  @media (max-width: 320px) {
    .tab-title {
      @include scaleimg(0.45);
    }
  }

  .subtitle {
    position: relative;
    width: 10vw;
    height: 65vh;
    left: 25vw;
    padding-top: 3rem;
    font-size: 0.875rem;
    line-height: 2em;
    writing-mode: vertical-lr;

    &.lng {
      width: 38vw;
      padding-top: 1rem;
      line-height: 1.5;
      writing-mode: unset;
    }
  }

  .content-show {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0.5rem;
    top: 30%;

    span {
      display: inline-block;
      width: 1em;
      line-height: 1;
      color: #6b6b6b;

      &.lng {
        width: auto;
      }
    }

    @include img-fluid;
    img {
      flex: none;
      display: block;
      width: 0.65rem;
      height: 2rem;
    }
  }
}

.method-content {
  @include full-box;
  position: relative;
  height: 100vh;
  z-index: 30;
  padding-top: 2rem;
  background-image: url("~@/assets/img/bg.jpg");
  background-size: cover;

  .textarea {
    height: 70vh;
    margin-left: 2rem;
    margin-right: 4rem;

    .text-main {
      padding-right: 1rem;

      p {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        font-size: 0.875rem;
      }

      @include title-h3(0.875rem);
    }
  }

  .video {
    h3 {
      color: $primary;
      text-decoration: underline;
    }
  }

  .sub-tabs {
    position: absolute;
    top: 2rem;
    right: 0;

    li {
      margin: 0.5rem;
      background-image: url("~@/assets/img/subtabs-h.png");
      background-size: 100%;
      font-size: 0.625rem;
      text-align: center;
      color: $text-dark;

      div {
        display: table-cell;
        width: 3.125rem;
        height: 3.125rem;
        vertical-align: middle;
      }
    }

    li.active {
      background-image: url("~@/assets/img/subtabs-a.png");
      font-weight: 900;
      color: $text-dark;
    }
  }

  .btn-arrow {
    margin-top: 1.5rem;
    margin-left: 1rem;
  }
}

.pyby-tabs .video-wrapper {
  z-index: 35;
}
</style>
